// frontend/src/pages/public/SolutionsIndex.jsx
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import Seo from "../../marketing/Seo";
import { Container, Section, Eyebrow } from "../../marketing/ui";
import { CTASection } from "../../marketing/blocks";
import { SOLUTIONS } from "../../marketing/data/solutions";

export default function SolutionsIndex() {
  return (
    <>
      <Seo
        title="Solutions — QR codes by industry"
        description="Practical ways to use dynamic QR codes in retail, restaurants, real estate, events, packaging and education."
        path="/solutions"
      />

      <div className="bg-gradient-to-b from-brand-50/60 to-white">
        <Container className="py-16 text-center sm:py-20">
          <Eyebrow>Solutions</Eyebrow>
          <h1 className="mx-auto mt-2 max-w-3xl text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Practical QR ideas for every industry
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-gray-600">
            See how teams use dynamic QR codes to connect the physical and digital — and
            change where every code points without reprinting.
          </p>
        </Container>
      </div>

      <Section>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SOLUTIONS.map((s) => (
            <Link
              key={s.slug}
              to={`/solutions/${s.slug}`}
              className="group rounded-2xl border border-gray-200 p-6 transition hover:border-brand-300 hover:shadow-sm"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50 text-brand-600">
                <s.icon className="h-6 w-6" aria-hidden="true" />
              </div>
              <h2 className="mt-4 flex items-center justify-between text-lg font-semibold text-gray-900">
                {s.name}
                <ArrowRightIcon className="h-5 w-5 text-gray-300 transition group-hover:translate-x-0.5 group-hover:text-brand-600" />
              </h2>
              <p className="mt-2 text-sm leading-6 text-gray-600">{s.subhead}</p>
            </Link>
          ))}
        </div>
      </Section>

      <CTASection
        title="Don't see your industry?"
        subtitle="QRFlow works anywhere a printed code meets a digital destination. Start free and build your own."
        primary={{ to: "/register", label: "Get started free" }}
        secondary={{ to: "/contact", label: "Talk to us" }}
      />
    </>
  );
}
